type LogLevel = 'log' | 'info' | 'warn' | 'error' | 'debug'

type XRayMessageTypes = '@mc/tracking-kit'

export interface XRayMessage {
  type: XRayMessageTypes
  level: LogLevel
  content: string | Record<string, unknown>
}

/**
 * Posts a message to the MasterClass X-Ray extension.
 * The extension will use the type attribute to determine how to handle the message.
 * Safely checks if window is available before posting.
 *
 * @param type - The type/category of the message (e.g., '@mc/tracking-kit')
 * @param level - The log level (matches console log levels)
 * @param content - The message content (string or object)
 */
export const postToXRay = (
  type: XRayMessageTypes,
  level: LogLevel,
  content: string | Record<string, unknown>,
) => {
  if (typeof window !== 'undefined') {
    const message: XRayMessage = {
      type,
      level,
      content,
    }
    window.postMessage(message, '*')
  }
}
